import { environment as Env } from './BaseEnvironments/Fortyfix';
import {addModule} from "./Utility/ModuleUtility";
import {GraficaFF} from "./Modules/GraficaFF";
import {Environment as defaultCrmEnv } from "./BaseEnvironments/DefaultCrm";
var Environment = () => {
  var env= Env;
  env.apiUrl= 'https://www.sbsprogetti.cloud/api';
  env.logoPath = 'assets/images/FF_Logo.png';
  env = addModule(GraficaFF("#8516a8"), env);
  env = addModule(defaultCrmEnv(), env);
  env.Menu.find(pl => pl?.id == 'att')?.submenu?.find(sl=> sl?.id == 'care')?.submenu.push(
    {
      id: 'C',
      module: "Clienti",
      path: "/task/task/edit/?type=C&tipo=237",
      title: "- Call",
      icon: "mdi mdi-account-group",
      capacita: [],
      class: ''
    },
    {
      id: 'MC', //meeting clienti
      module: "Clienti",
      path: "/task/task/edit/?type=C&tipo=236",
      title: "- Meeting",
      icon: "mdi mdi-account-group",
      capacita: [],
      class: ''
    },
    {
      id: 'S',
      module: "Clienti",
      path: "/task/task/edit/?type=C&tipo=238",
      title: "- Support",
      icon: "mdi mdi-account-group",
      capacita: [],
      class: ''
    },
  )

  return env;
}

export var environment = Environment();
